// Error copy for the users/team page: a translated backend code keeps its specific
// message, a duplicate email gets the page's own "email already registered" copy, and
// anything else (no code, unknown code, network failure) falls back to the action's
// message instead of the generic "something went wrong".
import type { TFunction } from 'i18next';
import { getErrorMessage } from '@startus/lib';

export type UserAction = 'fetch' | 'create' | 'update' | 'delete';

export function getUserErrorMessage(error: unknown, t: TFunction, action: UserAction): string {
  const code = error && typeof error === 'object' ? (error as { code?: string }).code : undefined;
  if (code === 'USER_ALREADY_EXISTS') return t('users.errors.emailExists');

  const message = getErrorMessage(error, t);
  return message === t('errors.generic', { ns: 'common' }) ? t(`users.errors.${action}`) : message;
}
